import { render } from "./ks-okved-view.vue?vue&type=template&id=30a77989"
import script from "./ks-okved-view.vue?vue&type=script&setup=true&lang=js"
export * from "./ks-okved-view.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/nsi/ks-okved-view.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "30a77989"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('30a77989', __exports__)) {
    api.reload('30a77989', __exports__)
  }
  
  module.hot.accept("./ks-okved-view.vue?vue&type=template&id=30a77989", () => {
    api.rerender('30a77989', render)
  })

}


export default __exports__